import Rect from '../../../../rect.js';
/**
 * Getters that operate on objects that have the following properties: 'x', 'y', 'width', 'height'
 */
function getters(options) {
  return {
    /**
     * Return the node rectangle
     * @param   {Object} node The node
     * @return  {Rect}        The node's rectangle
     */
    getRect(state) {
      return node => {
        return new Rect(
          node.x,
          node.x + node.width,
          node.y,
          node.y + node.height
        );
      };
    },

    /**
     * Return the bounding rectangle of the specified nodes
     * @param   {Array}  nodes  The nodes
     * @return  {Rect}          The nodes' bounding rectangle
     */
    getBoundingRect(state, getters) {
      return (nodes, byId = false) => {
        // If no nodes there is no bounding rectangle
        if (nodes === null || nodes.length === 0) {
          return null;
        }
        return Rect.boundingRect(
          nodes.map(node => {
            if (byId) {
              node = state.byId[node];
            }
            return getters.getRect(node);
          })
        );
      };
    },
  };
}

export default { getters };
